import React from 'react';
import { Modal, message, Spin } from 'antd';
import $ from '../../../common/AjaxRequest';
import ExportUtil from '../../../common/ExportUtil';
import API_URL from '../../../common/url';
import UpdateUI from './UpdateUI';
import { getMatchOption } from '../../shared/selectFn';
import format from '../../shared/format';

let path;
let Constants = {};
const getStatusByType = (type) => {
    switch(type) {
        case 'add':
            return {
                add: true,
                message: '新增成功',
                title: '新增子合同记录',
                saveUrl: API_URL.investigation.addChildrenJde,
            };
        case 'edit':
            return {
                edit: true,
                message: '修改成功',
                title: '修改子合同记录',
                saveUrl: API_URL.investigation.modifyChildrenJde,
            }
    }
};

class Update extends React.Component {
    state = {
        loading: false,
        visible: false,
        isDeductAmount: false,
        customerWritable: false,
        record: {},
        saveParams: {},
        investigation: {},
        baList: [],
        fileList: [],
        businessList: [],
        currencyList: [],
        signingUnitList: [],
        contractTypeList: [],
        belongingToUnitList: [],
        relationContractList: [],
        rateCanEdit: false,
    }

    secondLine_disabled = false       // 遗传办、安全事务不能编辑

    componentDidMount() {
        this.loadInvData();
        this.loadAllCurrencyExchangeRateList();
        this.querySigningUnit();
        this.queryWithLevelByParams('LINE_OF_BUSINESS');
        this.loadTypeConfigureList();
    }

    loadInvData = () => {
        this.setState({ loading: true });
        const { invId: investigationId } = sessionStorage;
        const options = {
            method: 'POST',
            url: API_URL.investigation.view,
            data: { investigationId },
            dataType: 'json',
            doneResult: res => {
                const { investigation } = res.data;
                this.setState({
                    investigation,
                    loading: false,
                });
            }
        };
        $.sendRequest(options);
    }

    querySigningUnit = () => {
        const options = {
            method: 'POST',
            url: API_URL.contract.queryUnitOfSigningList,
            data: {
                offset: 1,
                limit: 999,
            },
            dataType: 'json',
            doneResult: res => {
                this.setState({ signingUnitList: res.datas || [] });
            },
        };
        $.sendRequest(options);
    }

    queryWithLevelByParams = (typeName) => {
        const options = {
            method: 'POST',
            url: API_URL.common.queryWithLevelByParams,
            data: { typeName },
            dataType: 'json',
            doneResult: res => {
                this.setState({ businessList: res.typeConfigureList || [] });
            },
        };
        $.sendRequest(options);
    }

    loadTypeConfigureList = () => {
        const options = {
            method: 'POST',
            url: API_URL.common.typeConfigureList,
            data: {},
            dataType: 'json',
            doneResult: res => {
                this.setState({ contractTypeList: res.contractTypeList });
            }
        }
        $.sendRequest(options)
    }

    loadFileList = () => {
        const { saveParams: { investigationJdeContractId } } = this.state;
        if (investigationJdeContractId) {
            const options = {
                method: 'post',
                url: API_URL.contract.queryJdeCodeEnclosure,
                data: { investigationJdeContractId },
                dataType: 'json',
                doneResult: res => {
                    const fileList = res.data;
                    fileList.forEach((item, index) => {
                        item.response = {fileMetaId: item.id};
                        item.uid = index;
                    });
                    this.setState({ fileList });
                }
            };
            $.sendRequest(options);
        } else {
            this.setState({ fileList: [] });
        }
    }

    loadRelationContractList = () => {
        const { saveParams: { investigationJdeContractId } } = this.state;
        const options = {
            method: 'post',
            url: API_URL.contract.queryRelationJdeId,
            data: { notIncludeJdeCodeId : investigationJdeContractId },
            dataType: 'json',
            doneResult: res => {
                this.setState({ relationContractList: res.data || [] });
            }
        };
        $.sendRequest(options);
    }

    loadAllCurrencyExchangeRateList = () => {
        const options = {
            method: 'post',
            url: API_URL.contract.queryAllCurrencyExchangeRate,
            data: {},
            dataType: 'json',
            doneResult: res => {
                this.setState({ currencyList: res.data || [] });
            }
        };
        $.sendRequest(options);
    }

    show = (record, type) => {
        const { signingUnitList } = this.state;
        const {
            relateJdeIsDeductAmount,
            investigationJdeContractIsSpecifiesAmount,
            currencyCode,
            initialContractAmount,
            initialActualExpenseFee,
            initialActualFee,
            initialTaxationFee,
            baUserId,
            baName,
            baCode,
            unitOfSigningId,
            belongingToUnit,
            unitOfBelongingId,
            expectCnyContractAmount,
            expectInitialContractAmount,
            investigationJdeContractIsSigned,
            secondLineIds,
        } = record;
    
        const params = {
            expectContractAmount: expectCnyContractAmount,
            secondLineIds: secondLineIds ? secondLineIds + '' : '',
            jdeContractIsSpecifiesAmount: investigationJdeContractIsSpecifiesAmount,
            baUserId: baUserId ? baUserId : undefined,
            baUserName: baName && baCode ? `${baName}(${baCode})` : undefined,
        };
        if (currencyCode !== 'CNY') {
            params.jdeContractAmount = initialContractAmount;
            params.actualExpenseFee = initialActualExpenseFee;
            params.actualFee = initialActualFee;
            params.taxationFee = initialTaxationFee;
            params.expectContractAmount = expectInitialContractAmount;
        }

        path = Date.now();
        Constants = getStatusByType(type);
        this.secondLineIsEmpty = false;

        this.setState({
            visible: true,
            rateCanEdit: type == 'add' ? false : 'rmb',
            record,
            saveParams: {
                ...record,
                ...params,
                signingUnit: unitOfSigningId,
                belongingToUnit: unitOfBelongingId,
                belongingToUnitName: belongingToUnit,
            },
            isDeductAmount: relateJdeIsDeductAmount === '1',
            belongingToUnitList: getMatchOption(signingUnitList, 'unitOfSigningId', unitOfSigningId).belongings || [],
        }, () => {
            // 轮询项目信息是否请求完成
            const listenerLoading = () => {
                const { loading } = this.state;
                if (loading) {
                    setTimeout(listenerLoading, 10);
                } else {
                    this.initializeParams();
                }
            };
            listenerLoading();
            this.setDefaultCurrency();
            this.loadRelationContractList();
            if (Constants.edit) {
                this.loadFileList(investigationJdeContractIsSigned == 1 ? 'CONTRACT' : 'ADVANCE_WORK');
            }
        });
    }

    hide = () => {
        this.setState({
            fileList: [],
            visible: false,
            customerWritable: false,
        });
    }

    initializeParams = () => {
        const { saveParams, investigation, businessList } = this.state;
        const {
            investigationName,
            isClinicalProject,
            investigationSponsor,
            investigationCode,
            lineOfBusiness,
            lineOfBusinessString,
            secondLineIds,
            secondLineNames,
        } = investigation;
        saveParams.investigationSponsor = investigationSponsor;
        saveParams.investigationCode = investigationCode;
        saveParams.lineOfBusiness = lineOfBusiness;
        saveParams.lineOfBusinessString = lineOfBusinessString;
        saveParams.secondLineIds = saveParams.secondLineIds || secondLineIds || '';
        saveParams.secondLineNames = saveParams.secondLineNames || secondLineNames || '';

        this.secondLine_disabled = false;
        // 项目名称包含遗传办、安全事务，二级业务线自动赋值
        if (investigationName && isClinicalProject == 1 && lineOfBusiness) {
            let secondLineNames;
            let { childList } = getMatchOption(businessList, 'typeConfigureId', lineOfBusiness);
            if (investigationName.includes('遗传办')) {
                secondLineNames = '遗传办';
                this.secondLine_disabled = true;
            } else if (investigationName.includes('安全事务')) {
                secondLineNames = '安全事务';
                this.secondLine_disabled = true;
            }

            const { typeConfigureId } = getMatchOption(childList, 'typeValue', secondLineNames);
            if (typeConfigureId) {
                saveParams.secondLineIds = typeConfigureId;
                saveParams.secondLineNames = secondLineNames;
            }
        }

        this.secondLineIsEmpty = !saveParams.secondLineIds;

        this.setState({ saveParams });
    }

    // 新建时默认人民币
    setDefaultCurrency = () => {
        const { saveParams, currencyList } = this.state;
        if (Constants.add) {
            const { exchangeRate, currencyCode, currencyExchangeRateId } = getMatchOption(currencyList, 'currencyName', '人民币');
            saveParams.exchangeRate = exchangeRate;
            saveParams.currencyCode = currencyCode;
            saveParams.currencyExchangeRateId = currencyExchangeRateId;
        }
        this.setState({ saveParams });
    }

    submit = () => {
        const { loading, record, saveParams, fileList, businessList, relationContractList, customerWritable } = this.state;
        if (loading) return;
        const {
            jdeApplyId,
            investigationJdeContractId,
            investigationJdeContractCode,
            investigationJdeContractIsSigned,
            expectContractAmount,
            jdeContractAmount,
            rate,
            taxationFee,
            exchangeRate,
            actualExpenseFee,
            actualFee,
            currencyCode,
            isRealitySettle,//是否据实计算
            isMsaSpecialContractReduce,//是否从合同中扣减
            discountContractAmount
        } = saveParams;
        const isJdeCreate = !!jdeApplyId;
        const contractHasSigned = investigationJdeContractIsSigned == 1;
        const FIRST_CONTRACT = saveParams.contractNature === 'FIRST_CONTRACT';
        if (!isJdeCreate) {
            if (Constants.add) {
                if (!saveParams.investigationJdeContractCode) {
                    message.warning('请输入JDE项目号');
                    return;
                } else if (!(/^[0-9a-zA-Z]{12}$/.test(saveParams.investigationJdeContractCode))) {
                    message.warning('JDE项目号格式不正确:固定为12位，可由数字字母组成');
                    return;
                }
            }
            if (investigationJdeContractIsSigned == undefined) {
                message.warning('请选择合同或函证是否签署');
                return;
            }
            if (Constants.add && !saveParams.contractNature) {
                message.warning('请选择合同性质');
                return;
            }
            if (
                !!(!FIRST_CONTRACT || (Constants.add && relationContractList.length) || (Constants.edit && record.relationContractId))
                && !saveParams.relationContractId
            ) {
                message.warning('请选择关联JDE');
                    return;
            }
            if ((customerWritable || saveParams.contractNature !== 'RENEW_CONTRACT') && !saveParams.customerCompanyId) {
                message.warning('请选择客户全名');
                return;
            }
            if (!saveParams.baUserId) {
                message.warning('请选择BA');
                return;
            }
            
            const { childList: secondLineList } = getMatchOption(businessList, 'typeConfigureId', saveParams.lineOfBusiness);
            const showSecondLine = (secondLineList || []).length > 0;

            if (this.secondLineIsEmpty && showSecondLine && !(saveParams.secondLineIds || '').split(',').length) {
                message.warning('请选择执行业务线二级分类');
                return;
            }
            if (!saveParams.signingUnit) {
                message.warning('请选择合同签署单位');
                return;
            }
            if (!saveParams.belongingToUnit) {
                message.warning('请选择收入归属单位');
                return;
            }
            if (saveParams.investigationJdeContractIsSigned == 1 && !saveParams.jdeContractIsSpecifiesAmount) {
                message.warning('请选择合同中是否明标合同金额');
                return;
            }
            if (!saveParams.currencyExchangeRateId) {
                message.warning('请选择币种');
                return;
            }
            if (currencyCode !== 'CNY' && !saveParams.exchangeRate) {
                message.warning('请输入汇率');
                return;
            }
            if (!contractHasSigned) {
                if (expectContractAmount == undefined) {
                    message.warning('请输入预计合同金额');
                    return;
                }
                if (!fileList.length) {
                    message.warning('请上传提前上岗授权函');
                    return;
                }
            } else {
                if (jdeContractAmount == undefined) {
                    message.warning('请输入合同额含税');
                    return;
                } else {
                    if (saveParams.contractNature == 'FIRST_CONTRACT' && jdeContractAmount <= 0) {
                        message.warning('合同性质为“首次合同”时，合同额含税不支持负数和零');
                        return;
                    } else if (saveParams.contractNature !== 'SUPPLEMENT_CONTRACT' && jdeContractAmount == 0) {
                        message.warning('合同额含税不支持零');
                        return;
                    }
                }
                if (currencyCode !== 'CNY' && taxationFee == undefined) {
                    message.warning('请输入合同额税费');
                    return;
                }
                if (currencyCode !== 'CNY' && (!(taxationFee || taxationFee === 0) || !(rate || rate === 0))) {
                    message.warning('请输入合同税率或合同额税费');
                    return;
                }
                if (saveParams.contractNature == 'FIRST_CONTRACT' && saveParams.relationContractId && saveParams.relateJdeIsDeductAmount == undefined) {
                    message.warning('请选择关联JDE是否需要扣除相应金额');
                    return;
                }
                if(!investigationJdeContractIsSigned && !isRealitySettle && (isRealitySettle +'') !== "0"){
                    message.warning('请选择是否据实结算');
                    return;
                } 
                if( !investigationJdeContractIsSigned && isRealitySettle == 0 && isMsaSpecialContractReduce == 1 && !discountContractAmount){
                    message.warning('请输入优惠金额（含税）/人民币');
                    return;
                }
                if (!saveParams.startTime) {
                    message.warning('请输入合同开始时间');
                    return;
                }
                if (!saveParams.endTime) {
                    message.warning('请输入合同结束时间');
                    return;
                }
                if (saveParams.invoiceRate == undefined) {
                    message.warning('请输入发票税率');
                    return;
                }
                if (!saveParams.projectIdName) {
                    message.warning('请输入名称(ProjectID)');
                    return;
                }
                if (!saveParams.contractTypeId) {
                    message.warning('请选择计收入确认方式');
                    return;
                }
                if (!fileList.length) {
                    message.warning('请上传附件');
                    return;
                }
            }
        }

        const params = {
            ...saveParams,
            jdeCode: investigationJdeContractCode,
            jdeContractIsSigned: investigationJdeContractIsSigned,
            jdeCodeId: investigationJdeContractId,
            expectCnyContractAmount: expectContractAmount,
        };

        fileList.map((item, index) => {
            params[`ids[${index}]`] = item.response.fileMetaId;
        });
        params.startTime = format('date', saveParams.startTime);
        params.endTime = format('date', saveParams.endTime);

        if (currencyCode === 'CNY') {
            params.expectInitialContractAmount = '';  //预计合同金额（原币）
            params.initialContractAmount = '';  //合同额含税（原币）
            params.initialActualExpenseFee = '';  //实报实销费（原币）
            params.initialActualFee = ''; //实报实销税费(原币)
            params.initialTaxationFee = ''; //税费（原币）
        } else {
            params.expectInitialContractAmount = expectContractAmount;  //预计合同金额（原币）
            params.initialContractAmount = jdeContractAmount;  //合同额含税（原币）
            params.initialActualExpenseFee = actualExpenseFee;  //实报实销费（原币）
            params.initialActualFee = actualFee; //实报实销税费(原币)
            params.initialTaxationFee = taxationFee; //税费（原币）
        }

        if (currencyCode !== 'CNY') {
            params.expectCnyContractAmount = (expectContractAmount || expectContractAmount === 0) ? (expectContractAmount * exchangeRate).toFixed(2) : '';  //合同额含税（人民币）
            params.jdeContractAmount = (jdeContractAmount || jdeContractAmount === 0) ? (jdeContractAmount * exchangeRate).toFixed(2) : '';  //合同额含税（人民币）
            params.actualExpenseFee = (actualExpenseFee || actualExpenseFee === 0) ? (actualExpenseFee * exchangeRate).toFixed(2) : '';  //实报实销费（人民币）
            params.actualFee = (actualFee || actualFee === 0) ? (actualFee * exchangeRate).toFixed(2) : ''; //实报实销税费(人民币)
            params.taxationFee = (taxationFee || taxationFee === 0) ? (taxationFee * exchangeRate).toFixed(2) : ''; //税费（人民币）
        }

        this.sendServer(params, false);
    }

    sendServer = (params, isCheck) => {
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: Constants.saveUrl,
            data: {
                ...params,
                isCheck,
            },
            dataType: 'json',
            doneResult: res => {
                const { message: info } = res;
                if (info) {
                    Modal.confirm({
                        iconType: 'exclamation-circle',
                        title: <div style={{ marginLeft: 42 }}>{info}</div>,
                        onOk: () => {
                            this.sendServer(params, true);
                        },
                        onCancel: () => {
                            this.setState({ loading: false });
                        },
                    })
                } else {
                    message.success(Constants.message);
                    this.setState({
                        loading: false,
                    }, () => {
                        this.hide();
                        this.props.reload();
                    });
                }
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        }
        $.sendRequest(options);
    }

    handleChange = (value, key, rateCanEdit = true) => {
        const { saveParams, investigation } = this.state;
        switch  (key) {
            case 'investigationJdeContractIsSigned': {
                saveParams[key] = value;
                saveParams.jdeContractIsSpecifiesAmount = undefined;
                saveParams.expectContractAmount = undefined;
                saveParams.jdeContractAmount = undefined;
                saveParams.actualExpenseFee = undefined;
                saveParams.actualFee = undefined;
                saveParams.taxationFee = undefined;
                saveParams.rate = undefined;
                saveParams.relateJdeIsDeductAmount = undefined;
                saveParams.startTime = undefined;
                saveParams.endTime = undefined;
                saveParams.invoiceRate = undefined;
                saveParams.projectIdName = undefined;
                this.setState({ saveParams }, () => {
                    Constants.add && this.handleChange(undefined, 'contractNature');
                });
                break;
            }
            case 'contractNature': {
                saveParams[key] = value;
                this.setState({ saveParams }, () => {
                    this.handleChange(undefined, 'relationContractId');
                });
                break;
            }
            case 'relationContractId': {
                saveParams[key] = value;
                const { relationContractList } = this.state;
                const {
                    customerCompanyId,
                    customerCompanyName,
                    customerJdeCode,
                    isDiscountTermValidity,//是否优惠有效期内
                    isMsaSpecialDiscountCustom,//是否优惠客户
                } = getMatchOption(relationContractList, 'investigationJdeContractId', value);

                const DiscountTermValidity = isDiscountTermValidity || undefined;
                const MsaSpecialDiscountCustom = isMsaSpecialDiscountCustom || undefined;
                this.handleChange(DiscountTermValidity , 'isDiscountTermValidity' );
                this.handleChange(MsaSpecialDiscountCustom , 'isMsaSpecialDiscountCustom' );

                const { contractNature } = saveParams;
                this.setState({
                    saveParams,
                    customerWritable: value && contractNature === 'RENEW_CONTRACT' && !customerCompanyId,
                }, () => {
                    this.handleChange({value: customerCompanyId, text: customerCompanyName, customerCompanyCode: customerJdeCode}, 'customerCompany');
                });
                break;
            }
            case 'customerCompany': {
                const { value: id, text: name, customerCompanyCode } = value;
                saveParams.customerCompanyId = id;
                saveParams.customerCompanyName = name;
                saveParams.customerJdeCode = customerCompanyCode;
                saveParams.baUserId = undefined;
                saveParams.baUserName = undefined;
                this.setState({ saveParams });
                break;
            }
            case 'baUser': {
                const { value: id, text: name } = value;
                saveParams.baUserId = id;
                saveParams.baUserName = name;
                this.setState({ saveParams });
                break;
            }
            case 'signingUnit': {
                saveParams[key] = value;
                const { signingUnitList } = this.state;
                const belongingToUnitList = getMatchOption(signingUnitList, 'unitOfSigningId', value).belongings || [];
    
                if (value && !belongingToUnitList.length) {
                    message.warning('收入归属单位不能为空，请联系后台管理员为合同签署单位设置收入归属单位');
                    return;
                }
                let belongingToUnit,
                    belongingToUnitName;
                if (belongingToUnitList.length === 1) {
                    [{ unitOfBelongingId: belongingToUnit, unitOfBelongingName: belongingToUnitName }] = belongingToUnitList;
                }
                saveParams.belongingToUnit = belongingToUnit;
                saveParams.belongingToUnitName = belongingToUnitName; 
                this.setState({
                    saveParams,
                    belongingToUnitList,
                });
                break;
            }
            case 'currencyExchangeRateId': {
                saveParams[key] = value;
                const { currencyList } = this.state;
                const { exchangeRate, currencyName, currencyCode } = getMatchOption(currencyList, 'currencyExchangeRateId', value);
                saveParams.exchangeRate = exchangeRate;
                saveParams.currencyName = currencyName;
                saveParams.currencyCode = currencyCode;
                this.setState({ saveParams });
                break;
            }
            case 'lineOfBusiness':
                saveParams.lineOfBusiness = value;
                saveParams.lineOfBusinessString = undefined;
                saveParams.secondLineIds = '';
                this.setState({ saveParams });
                break;
            case 'secondLineIds': {
                const { isClinicalProject } = investigation;
                // 系统中没有该项目、是临床项目、是以下业务线时单选
                const singleSelect = isClinicalProject == 1;
                if (singleSelect) {
                    saveParams.secondLineIds = value;
                } else {
                    saveParams.secondLineIds = (value || []).join(',');
                }
                this.setState({ saveParams });
                break;
            }
            case 'isRealitySettle':
                saveParams.isRealitySettle = value;
                if(value == 1){
                    saveParams.isMsaSpecialContractReduce = null;
                    saveParams.discountContractAmount = null;
                }else if(value == 0){
                    saveParams.isMsaSpecialContractReduce = 0;
                    saveParams.discountContractAmount = null;
                }
                this.setState({ saveParams });
                break;
            case 'isMsaSpecialContractReduce':
                saveParams.isMsaSpecialContractReduce = value;
                if(value == 0 ){
                    saveParams.discountContractAmount = null;
                }
                this.setState({ saveParams });
                break;
            case 'discountContractAmount':
                if(value){
                    if(typeof(value) == typeof('') && value.substring(0,1) === '-'){
                        saveParams.discountContractAmount = value.slice(1);
                    }
                    else{
                        saveParams.discountContractAmount = value
                    }
                }else{
                    saveParams.discountContractAmount = null;
                }
                this.setState({ saveParams });
                break;
            case 'isMsaSpecialDiscountCustom'://是否优惠客户
                saveParams[key] = value;
                if( !value || value == 0 ){
                    saveParams.isMsaSpecialContractReduce = null;
                    saveParams.discountContractAmount = null;
                }
                this.setState({ saveParams });
            break;
            case 'isDiscountTermValidity'://是否优惠有效期
                saveParams[key] = value;
                if(!value || value == 0){
                    saveParams.isMsaSpecialContractReduce = null;
                    saveParams.discountContractAmount = null;
                }else if(value == 1 ){
                    saveParams.isMsaSpecialContractReduce = 0;
                    saveParams.discountContractAmount = null;
                }
                this.setState({ saveParams });
            break;
            case 'rate'://合同税率
                saveParams[key] = value;
                rateCanEdit && this.setState({ saveParams, rateCanEdit: 'rate' });
            break;
            case 'taxationFee'://合同额税费/人民币
                saveParams[key] = value;
                rateCanEdit && this.setState({ saveParams, rateCanEdit: 'rmb' });
            break;
            default: {
                saveParams[key] = value;
                this.setState({ saveParams });
                break;
            }
        }
    }

    beforeUpload = file => {
        const { fileList = [] } = this.state;
        const isLt30M = file.size / 1024 / 1024 <= 30;
        if (fileList.length >= 10) {
            message.warning('最多上传10个附件');
            return false;
        }
        if (!isLt30M) {
            message.warning('文件大小不能超过30M');
            return false;
        }
    }

    handleUploadChange = ({file, fileList}) => {
        if (file.status == "done") {
            if (file.response.error) {  
                message.error(file.response.error);
                file.status = 'removed';
                const fileData = [...this.state.fileList];
                const index = fileData.indexOf(file);
                fileList.splice(index, 1);
            } else if (file.response.success) {
                message.success('上传附件成功');
            }
        }
        this.setState({fileList});
    }

    handleRemove = file => {
        const options = {
            method: 'POST',
            url: API_URL.contract.deleteJdeCodeEnclosure,
            data: {
                fileMetaId: file.response.fileMetaId,
            },
            dataType: 'json',
            doneResult: res => {
                if (res.error) {
                    message.error(res.error);
                } else {
                    message.success(res.success);
                }
            }
        };
        $.sendRequest(options);
    }

    downLoadFile = (e, fileMetaId) => {
        const url = API_URL.contract.downloadJdeCodeEnclosure;
        ExportUtil.export({ fileMetaId }, null, url);
    }

    handleChangeRateCanEdit = value => {
        this.setState({ rateCanEdit: value })
    }

    getDataList = () => {
        const {
            isDeductAmount,
            customerWritable,
            record,
            saveParams,
            investigation,
            baList,
            fileList,
            businessList,
            currencyList,
            signingUnitList,
            contractTypeList,
            belongingToUnitList,
            relationContractList,
            rateCanEdit,
        } = this.state;

        const setting = {
            path,
            Constants,
            isDeductAmount,
            customerWritable,
            record,
            saveParams,
            investigation,
            baList,
            fileList,
            businessList,
            currencyList,
            signingUnitList,
            contractTypeList,
            belongingToUnitList,
            relationContractList,
            rateCanEdit,
        };

        return (
            <UpdateUI
                {...setting}
                secondLine_disabled={this.secondLine_disabled}
                secondLineIsEmpty={this.secondLineIsEmpty}
                downLoadFile={this.downLoadFile}
                handleChange={this.handleChange}
                beforeUpload={this.beforeUpload}
                handleUploadChange={this.handleUploadChange}
                handleChangeRateCanEdit={this.handleChangeRateCanEdit}
                handleRemove={this.handleRemove}
            />
        );
    }

    render() {
        const { visible, loading } = this.state;
        return (
            <Modal
                title={Constants.title}
                visible={visible}
                onCancel={this.hide}
                onOk={this.submit}
                maskClosable={false}
                confirmLoading={loading}
                wrapClassName="vertical-center-modal"
                bodyStyle={{ maxHeight: 500 }}
                width="700px"
            >
                <Spin spinning={loading}>
                    { this.getDataList() }
                </Spin>
            </Modal>
        )    
    }
}

export default Update;


// WEBPACK FOOTER //
// ./src/components/projectContract/childContract/Update.js